import {HttpInterceptorFn, HttpResponse} from '@angular/common/http';
import {inject} from "@angular/core";
import {HttpLoadingService} from "../services/app/http-loading.service";
import {finalize, tap} from "rxjs";
import {MessageService} from "primeng/api";
import {Router} from "@angular/router";

export const httpLoadingInterceptor: HttpInterceptorFn = (req, next) => {
    const httpLoadingService: HttpLoadingService = inject(HttpLoadingService);
    const messageService: MessageService = inject(MessageService);
    const router: Router = inject(Router);

    httpLoadingService.addQuery(req.urlWithParams);

    return next(req).pipe(
        finalize(() => {
            httpLoadingService.removeQuery(req.urlWithParams);
        })
    ).pipe(
        tap(
            event => event instanceof HttpResponse ? 'succeeded' : '',
            err => {
                if (err.status > 299) {
                    let errorString = '';
                    if(err.error && err.error.validation_messages) {

                        errorString += '<ul>';
                        let errors = Object.keys(err.error.validation_messages);
                        errors.forEach(function (e) {
                            errorString += '<li><b>' + e + '</b><br>' + Object.values(err.error.validation_messages[e])[0] + '</li>';
                        });
                        errorString += '</ul>';
                    }

                    if (err.status === 403) {
                        console.log(err);
                        messageService.add({
                            severity: 'error',
                            summary: 'Permission mismatch!',
                            detail: err.error.title + ': ' + err.error.detail,
                            life: 5000
                        });

                        //fuck around/find out
                        router.navigateByUrl('/');
                    } else {
                        messageService.add({
                            severity: 'error',
                            summary: 'An error occured!',
                            detail: err.status + ': ' + err.error.detail + errorString,
                            life: 10000
                        });
                    }
                }
            }
        )
    );
};
